import { Pipe, PipeTransform } from '@angular/core';
import dayjs from '../dayjs-config';

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

  transform(date: dayjs.ConfigType, format: string): string {
    return dayjs(date).format(format)
  }

}

@Pipe({
  name: 'momentTz'
})
export class MomentTzPipe implements PipeTransform {

  transform(date: dayjs.ConfigType, format: string, timezone: string): string {
    return dayjs.tz(date, timezone).format(format)
  }

}
